// EMİR #89.1 — View Transitions güvenli sarma (progressive-enhancement).
//
// document.startViewTransition() ile SPA görünüm geçişlerine akışkan cross-fade
// (IG "profil→gönderi", "liste→detay" hissi). KRİTİK: feature-detection ile
// progressive — desteklemeyen tarayıcı (eski iOS Safari <18) veya reduced-motion
// → BİREBİR mevcut davranış (apply doğrudan çağrılır, sıfır regresyon).
//
// Kilitli oynatma/feed geçişlerinde KULLANILMAZ (pager/poster hassas). Yalnız
// düz sayfa geçişleri (profil, keşfet, DM listesi, ayarlar).
import { flushSync } from "react-dom";

type ApplyFn = () => void;

function prefersReducedMotion(): boolean {
  try {
    return typeof window !== "undefined"
      && typeof window.matchMedia === "function"
      && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch (_) {
    return false;
  }
}

/**
 * `apply`'ı bir View Transition içinde uygular (destekliyse). React state
 * güncellemesi flushSync ile SENKRON uygulanır (VT callback'i senkron DOM
 * değişikliği bekler). Destek yoksa / reduced-motion / hata → düz apply.
 *
 * @param apply Görünümü değiştiren senkron fonksiyon (setState çağrıları).
 */
export function withViewTransition(apply: ApplyFn): void {
  const doc = document as Document & { startViewTransition?: (cb: () => void) => unknown };
  if (typeof apply !== "function") return;
  // Progressive: destek yok VEYA hareket-azalt → mevcut davranış birebir.
  if (typeof doc.startViewTransition !== "function" || prefersReducedMotion()) {
    apply();
    return;
  }
  try {
    doc.startViewTransition(() => {
      // flushSync: VT'nin snapshot alması için DOM'un callback İÇİNDE senkron
      // değişmesi şart (React batch'ini zorla boşalt). Event handler'da güvenli.
      flushSync(apply);
    });
  } catch (_) {
    // startViewTransition/flushSync herhangi bir nedenle patlarsa → düz apply
    // (kullanıcı akışı ASLA kırılmaz; geçiş animasyonu "nice-to-have").
    apply();
  }
}

export default withViewTransition;
